import SmartNavigator from '../generic/SmartNavigator'
import GenericKPIs from '../dashboard/GenericKPIs'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import useSmartTranslation from '../generic/hooks/useSmartTranslation/useSmartTranslation'

const MainDashboardProduction = ({ activePath }) => {
  const [config] = useFrontEndConfig()

  const { t_ } = useSmartTranslation()

  if (config === null) return null

  const componentsInfo = [
    {
      title: t_('Worker Monitoring'),
      component: <GenericKPIs dashboardsUrl='/dashboards/d/demnurgwc4l4wf' />,
      permissionCode: 'DASHBOARD_PRODUCTION_WORKER'
    },
    {
      title: t_('Device Monitoring'),
      component: <GenericKPIs dashboardsUrl='/dashboards/d/demnurgwc4l4wf' />,
      permissionCode: 'DASHBOARD_PRODUCTION_DEVICE'
    },
    {
      title: t_('Work In Progress'),
      component: <GenericKPIs dashboardsUrl='/dashboards/d/demnurgwc4l4wf' />,
      permissionCode: 'DASHBOARD_PRODUCTION_WIP'
    },
    {
      title: t_('Quality'),
      component: <GenericKPIs dashboardsUrl='/dashboards/d/demnurgwc4l4wf' />,
      permissionCode: 'DASHBOARD_PRODUCTION_QUALITY'
    }
  ]

  return <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
}

export default MainDashboardProduction
